import { useState, useEffect, useCallback } from "react";
import { getEmpresas } from "../../../services/SubproductoService.js";

const useEmpresas = (baseUrl) => {
  const [empresa, setEmpresa] = useState(null);
  const [listaEmpresas, setListaEmpresas] = useState([]);

  const cargarEmpresas = useCallback(async () => {
    try {
      const empresas = await getEmpresas(baseUrl);
      setListaEmpresas(empresas);
      if (empresas && empresas.length > 0) {
        setEmpresa(empresas[0].id);
      }
    } catch (error) {
      console.error("Error al obtener las empresas:", error);
    }
  }, [baseUrl]);

  useEffect(() => {
    cargarEmpresas();
  }, [cargarEmpresas]);

  const nombreEmpresa = listaEmpresas.find((item) => item.id === empresa)?.nombre;

  return { empresa, setEmpresa, listaEmpresas, nombreEmpresa };
};

export default useEmpresas;
